module.exports = __webpack_public_path__ + "static/logos-tiles-leclerc-0847e0b6f06448eb4a140f0fbcded377.svg";